// The 5 SS claiming strategies surfaced in the comparison table.
// Must stay in sync with the C# SocialSecurityStrategy enum (SocialSecurityComparisonModels.cs).
export const SOCIAL_SECURITY_STRATEGIES = [
  'ActivePlan',
  'AsSoonAsPossible',
  'AtRetirement',
  'AtFra',
  'AtAge70',
] as const;

export type SocialSecurityStrategy = typeof SOCIAL_SECURITY_STRATEGIES[number];

export interface SocialSecurityMonthlyBenefitsWhatIf {
  WhatIfType: 'RetirementSocialSecurityMonthlyBenefits';
  SocialSecurityStartAgePrincipal: number;
  SocialSecurityStartAgeSpouse: number;
  SocialSecurityAmountPrincipal: number;
  SocialSecurityAmountSpouse: number;
  SocialSecurityCurrentlyReceivingBenefitsPrincipal: boolean;
  SocialSecurityCurrentlyReceivingBenefitsSpouse: boolean;
  SocialSecurityUseSpousalBenefit: boolean;
  SocialSecurityFileForSurvivorBenefits: boolean;
  UseFraPrincipal: boolean;
  UseFraSpouse: boolean;
}

export type SocialSecurityWhatIf = SocialSecurityMonthlyBenefitsWhatIf | Record<string, unknown>;
